import { changeRoundStateAction } from 'core/widgets/RoundStates/actions';
import { put } from 'redux-saga/effects';
import { Notifications } from 'types';
import { RoundStates } from '../../RoundStates/types';
import { OnRoundFinishedData } from '../types';
import { setHotColdAnalytics } from 'core/widgets/HotColdAnalytics/actions';

export function* onRoundFinishedSaga({ type: notificationType, data }: OnRoundFinishedData) {
  if (notificationType === Notifications.ROUND_FINISHED) {
    yield put(changeRoundStateAction({ roundState: RoundStates.RoundFinished }));

    const { hotColdAnalytic } = data;
    if (hotColdAnalytic.length !== 0) {
      yield put(setHotColdAnalytics(hotColdAnalytic));
    }
  }
}
